import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button } from '@mui/material';
import { FormInput } from 'components/input/hook-form';
import ButtonLoader from 'components/loader/ButtonLoader';
import { IForgotPasswordRequestBody } from 'interfaces/forgot-password';
import { useForgotPasswordRequestMutation } from 'lib/api/authApi';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useNavigate, useParams } from 'react-router';

import * as yup from 'yup';

const EmployeeForgotPasswordRequestForm = () => {
    const [loading, setLoading] = useState(false);
    const [forgotPasswordRequest] = useForgotPasswordRequestMutation();
    const navigate = useNavigate();

    const { handleSubmit, control } = useForm<IForgotPasswordRequestBody>({
        mode: 'onSubmit',
        resolver: yupResolver(
            yup
                .object({
                    email: yup.string().email().required('*Email is required')
                })
                .required()
        )
    });

    const onSubmit = (data: IForgotPasswordRequestBody) => {
        setLoading(true);
        forgotPasswordRequest(data)
            .unwrap()
            .then((response) => {
                withReactContent(Swal).fire('Sukses', 'Forgot password request successful!', 'success');
                navigate(`/forgot-password/${response.data?.sessionId}`);
            })
            .catch((error) => {
                withReactContent(Swal).fire('Error', error.data?.message || 'An error occurred while processing your request.', 'error');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ mb: 20 }}>
                <FormInput control={control} label="Email" name="email" />
            </Box>

            <Box sx={{ mt: 2 }}>
                {loading ? (
                    <ButtonLoader />
                ) : (
                    <Button disableElevation fullWidth size="large" type="submit" variant="contained" color="secondary">
                        Send Forgot Password Request
                    </Button>
                )}
            </Box>
        </form>
    );
};

export default EmployeeForgotPasswordRequestForm;
